import { onMount, onDestroy } from "@/modules/_";
import { prepLineDraw, playLineDraw, cleanLineDraw } from "@utils/line-draw";

export default function (element: HTMLElement, _dataset: DOMStringMap) {
  const prepared = prepLineDraw(element);
  if (!prepared) return;

  onMount(() => {
    playLineDraw(prepared, { delay: 0.4 });
  });

  onDestroy(() => {
    cleanLineDraw(prepared.path);
  });
}
